import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import InviteAccept from "@/pages/InviteAccept";
import InviteDecline from "@/pages/InviteDecline";
import PlaceAccept from "@/pages/PlaceAccept";
import PlaceDecline from "@/pages/PlaceDecline";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("dynamo_token");
  if (!token) return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        {/* Public invite response pages — no auth required */}
        <Route path="/invite/accept"  element={<InviteAccept />} />
        <Route path="/invite/decline" element={<InviteDecline />} />
        <Route path="/place/accept"   element={<PlaceAccept />} />
        <Route path="/place/decline"  element={<PlaceDecline />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
